import packageJson from '../../package.json';
export default {
  version: packageJson.version,
  iv: 'f7f3920c6769ac04b443ba33bd4810ad780feccb033cbbcc3eb024a7038b579d',
  key: '5351903033b0542f0df90c6f94a4e6ed',
};
